import axios from 'axios';

/*
The manager server's /s3 presign, with the admin token.

/s3 checks the same admin JWT the GraphQL client sends to ps-back
(src/api/graphql/graphqlAPI.js reads it from localStorage), so every caller goes through
here instead of calling axios.get('/s3') bare. `params` are passed through:
{ fileName, fileType, type } for an upload URL, { fileName, getObject: true } for a
signed read URL. `axiosOptions` lets a caller add e.g. a cancel token.
*/
export const adminAuthHeaders = () => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem(process.env.AUTH_TOKEN) : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const presignS3 = (params, axiosOptions = {}) => axios.get('/s3', {
  ...axiosOptions,
  params,
  headers: { ...(axiosOptions.headers || {}), ...adminAuthHeaders() },
});

export default presignS3;
